<template>
  <div v-if="mcSummary" class="micro-competency-popup-section">
    <b-btn id="mcSummaryProgressBar" style="position: relative; width: 225px; padding:0">
        <div class="mc_progress_bar_label" :aria-label="notInThePlanValue + '/' + mcSummary.childrenCount" :title="'Completed ' + notInThePlanValue + ' out of ' + mcSummary.childrenCount + ' competencies'" v-b-tooltip.hover>
          {{ notInThePlanValue + '/' + mcSummary.childrenCount }}
        </div>
        <b-progress :max="mcSummary.childrenCount">
            <b-progress-bar :value="mcSummary.childrenCompleteCount" class="sts_blc_Cmplt"></b-progress-bar>
            <b-progress-bar :value="mcSummary.childrenInProgressCount" class="sts_blc_Prgs"></b-progress-bar>
            <b-progress-bar :value="mcSummary.childrenFailedCount" class="sts_blc_Fail"></b-progress-bar>
            <b-progress-bar :value="inThePlanValue" class="sts_blc_NotStarted"></b-progress-bar>
        </b-progress>
    </b-btn>
	<div id="microCompetencyPopup" class="micro-competency-popup"></div>
    <div>
        <b-popover target="mcSummaryProgressBar" triggers="click blur" container="microCompetencyPopup" placement="left" :offset="60" @show="onShow">
            <template slot="title"></template>
	            <div class="progressBar">
                <div class="mc_popover_progress_bar_label">{{ notInThePlanValue + '/' + mcSummary.childrenCount }}</div>
                <b-progress height="30px" :max="mcSummary.childrenCount">
                    <b-progress-bar :value="mcSummary.childrenCompleteCount" class="sts_blc_Cmplt"></b-progress-bar>
                    <b-progress-bar :value="mcSummary.childrenInProgressCount" class="sts_blc_Prgs"></b-progress-bar>
                    <b-progress-bar :value="mcSummary.childrenFailedCount" class="sts_blc_Fail"></b-progress-bar>
                    <b-progress-bar :value="inThePlanValue" class="sts_blc_NotStarted"></b-progress-bar>
                </b-progress>
            </div>
            <div class="status_row"><span class="completed icon-progress"></span> {{mcSummary.childrenCompleteCount}} completed</div>
            <div class="status_row"><span class="in_progress icon-progress"></span> {{mcSummary.childrenInProgressCount}} in progress</div>
            <div class="status_row"><span class="failed icon-progress"></span> {{mcSummary.childrenFailedCount}} needs improvement</div>
            <div class="status_row"><span class="not_started icon-progress"></span> {{mcSummary.childrenCount - mcSummary.childrenCompleteCount - mcSummary.childrenInProgressCount - mcSummary.childrenFailedCount}} not started</div>
            <div class="competency-result">You have finished {{ competencySummary.childrenCompleteCount }} /  {{ competencySummary.childrenCount }}.</div>
        </b-popover>
    </div>

  </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    export default {
      name: 'microCompetencySummary',
      props: ['entityId'],
      data: () => {
        return {}
      },

      mounted () {
        if (this.entityId) {
          this.loadMicroCompetencySummary()
        }
      },

      methods: {
        ...mapActions([
          'loadCompetencyProgress',
          'loadMicroCompetencyProgress',
          'loadLogDashboardActivity'
        ]),

        loadMicroCompetencySummary () {
          this.loadMicroCompetencyProgress({entityId: this.entityId, loadDataFromServer: true}).then(res => {
            this.loadCompetencyProgress({entityId: this.entityId, loadDataFromServer: true})
          })
        },

        onShow () {
          this.loadLogDashboardActivity({action: 'clickCompetencyProgress', page: 'courseHeader', link: '', entityUuid: this.entityId})
        }
      },

      computed: {
        ...mapState({
          'competencySummary': state => state.course.competencySummary,
          'mcSummary': state => state.course.mcSummary
        }),

        notInThePlanValue: function () {
          return this.mcSummary.childrenCompleteCount + this.mcSummary.childrenInProgressCount + this.mcSummary.childrenFailedCount
        },

        inThePlanValue: function () {
          return this.mcSummary.childrenCount - this.notInThePlanValue
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/app/course/components/MicroCompetencySummary.vue